import React from "react";
import Swiper from "react-id-swiper";
import { Pagination, Autoplay } from "swiper/dist/js/swiper.esm";

import slide01 from "Assets/Images/slide01.jpg";
import slide02 from "Assets/Images/slide02.jpg";
import slide03 from "Assets/Images/slide03.jpg";

export default class extends React.Component {
  render() {
    const params = {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      }
    };
    return (
      <Swiper {...params}>
        <div>
          <img src={slide01} alt="slide01" />
        </div>
        <div>
          <img src={slide02} alt="slide02" />
        </div>
        <div>
          <img src={slide03} alt="slide03" />
        </div>
      </Swiper>
    );
  }
}
